import * as React from "react";
import { Grid, Stack, Text } from "@chakra-ui/react";
import siteConfig from "configs/site-config";
import { Page, Section } from "components/page";

interface EntryProps {
  year: number;
  children: React.ReactNode;
}

const Entry = ({ year, children }: EntryProps) => (
  <Grid templateColumns="3.25rem 1fr" columnGap={4}>
    <Text fontFamily="mono" fontSize="sm" color="muted" pt="0.15rem">
      {year}
    </Text>
    <Text sx={{ overflowWrap: "anywhere" }}>{children}</Text>
  </Grid>
);

const Publications = () => {
  const { pubs, preprints, posters } = siteConfig.publications;
  const groups = [
    { label: "Journal articles", items: pubs },
    { label: "Preprints", items: preprints },
    { label: "Posters", items: posters },
  ].filter((group) => group.items.length > 0);

  return (
    <Page
      title="Publications"
      intro={
        <Text className="prose" fontFamily="mono" fontSize="sm">
          Updated June 2026 ·{" "}
          <a href="https://scholar.google.com/citations?hl=en&user=wJd-E18AAAAJ">Google Scholar</a>
        </Text>
      }
    >
      {groups.map((group) => (
        <Section key={group.label} label={group.label}>
          <Stack spacing={7} className="prose">
            {group.items.map((pub, index) => (
              <Entry key={index} year={pub.year}>
                {pub.text}
              </Entry>
            ))}
          </Stack>
        </Section>
      ))}
    </Page>
  );
};

export default Publications;
